module.exports = __webpack_public_path__ + "img/baiyin@2x.53867dd5.png";